import { render, staticRenderFns } from "./ChooseRecycleDisposalPatternBotton.vue?vue&type=template&id=15fdcb37&"
import script from "./ChooseRecycleDisposalPatternBotton.vue?vue&type=script&lang=js&"
export * from "./ChooseRecycleDisposalPatternBotton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports